import { graphql, useStaticQuery } from 'gatsby';

export function useFullProjectsCards() {
  const {
    allProjectPreview: { nodes: previews },
  } = useStaticQuery(graphql`
    query {
      allProjectPreview {
        nodes {
          id
          cooperation_time
          country
          countryFlag
          description
          img {
            desktop
            desktop_webp
            mobile
            mobile_webp
          }
          bigImage {
            desktop
            desktop_webp
            mobile
            mobile_webp
          }
          industry
          isNda
          logo
          logo_color
          ndaCustomerDescription
          project_url
          services
          tags
          technologies
          title
          video
        }
      }
    }
  `);

  return previews;
}
